module.exports = __webpack_public_path__ + "img/image.0792d7ea.svg";